import { createSelector } from 'reselect'
import { receiveSegmentList } from './actions'
import { SegmentStatus } from './models'

const root = state => state.get('segment')

const endUserMemberships = (state) => root(state).get('endUserMembership')

export const endUserMembershipById = createSelector(
  [
    endUserMemberships,
    (state, props) => props.endUserId
  ],
  (endUserMemberships, endUserId) => endUserMemberships.get(endUserId))

export const endUserMembershipByIdFetched = createSelector(
  [
    endUserMemberships,
    (state, props) => props.endUserId
  ],
  (endUserMemberships, endUserId) => endUserMemberships.has(endUserId))

export const byId = createSelector(root, root => root.get('byId'))
const segmentListStatus = createSelector(root, root => root.get('segmentStatus'))
export const segmentListLoaded = createSelector(segmentListStatus, segmentListStatus => segmentListStatus === receiveSegmentList.toString())

export const endUserSegments = createSelector(
  [
    endUserMembershipById,
    byId,
  ],
  (endUserMembershipById, byId) => byId.filter(segment => _.includes(endUserMembershipById, segment.id))
)

const cardinalityByIdSet = createSelector(root, root => root.get('cardinalityByIdSet'))
export const segments = createSelector(
  byId,
  byId => {
    return byId
      .valueSeq()
      .filter(({ status }) => status !== SegmentStatus.HIDDEN)
  }
)
export const endUserCount = (state, props) => cardinalityByIdSet(state).get(props.segmentSet)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/segment/selectors.js